module.exports={
	"Form": "TestSpecificationSetCreateManifest",
	"Scope": "TestSpecificationSet-Create",
	"Descriptors":
	{
		"TestSpecificationSetDetails.Name":
		{
			"Name": "Name",
			"Hash": "TestSpecificationSet-Create-Name",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "1",
				"Width": 6,
				"Section": "TestSpecificationSet-Create-Identity",
				"Group": "TestSpecificationSet-Create-Identity"
			}
		},
		"TestSpecificationSetDetails.Year":
		{
			"Name": "Year",
			"Hash": "TestSpecificationSet-Create-Year",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "2",
				"Width": 4,
				"Section": "TestSpecificationSet-Create-Details",
				"Group": "TestSpecificationSet-Create-Details"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "TestSpecificationSet-Create-Identity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "TestSpecificationSet-Create-Identity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Details",
			"Hash": "TestSpecificationSet-Create-Details",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Details",
					"Hash": "TestSpecificationSet-Create-Details",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}
